import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/services/services-catalogue')({
  component: Outlet,
  context: () => {
    return {
      getBreadcrumbData: () => ({
        id: null,
        translationKey: 'breadcrumbs.servicesCatalogue',
      }),
    };
  },
});
